import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../components/Loading';
import {theme} from '../constants';

type DataItem = {
  id: number;
  name: string;
};

type Props = {
  data: DataItem[];
  next: () => void;
  hasMore: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  endMessage?: React.ReactNode;
};

export const InfiniteScrollR: React.FC<Props> = ({
  data = [],
  next,
  hasMore,
  loading,
  children,
  style,
  endMessage,
}) => {

  return (
    <InfiniteScroll
      className="min-h-screen bg-gray-100 pt-3"
      dataLength={data.length}
      next={next}
      hasMore={hasMore}
      loader={
        loading ? (
          <Loading/>
        ) : null
      }
      style={style}
      endMessage={
        endMessage && (
          <p
            style={{
              textAlign: 'center',
              marginTop: 20,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
            }}
          >
              .همه آیتم ها را دیده اید
          </p>
        )
      }
    >
      {children}
    </InfiniteScroll>
  );
};
